import { APP_STORE_IOS_URL, APP_STORE_ANDROID_URL } from "@/lib/config"
import { AppStoreButton } from "./AppStoreButton"
import { GooglePlayButton } from "./GooglePlayButton"

interface AppStoreButtonsProps {
  className?: string
}

export const AppStoreButtons = ({ className = "" }: AppStoreButtonsProps) => {
  const iosUrl = APP_STORE_IOS_URL
  const androidUrl = APP_STORE_ANDROID_URL

  // If neither app store URL is configured, show waitlist instead
  if (!iosUrl && !androidUrl) {
    return null
  }

  return (
    <div className={`flex flex-row gap-3 items-center justify-center ${className}`}>
      <AppStoreButton />
      <GooglePlayButton />
    </div>
  )
}
